import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SupabaseService } from 'src/app/core/services/base/supabase.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-download-document',
  templateUrl: './download-document.component.html',
  styleUrls: ['./download-document.component.scss'],
})
export class DownloadDocumentComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { signed_document_id: string },
    public dialogRef: MatDialogRef<DownloadDocumentComponent>,
    private http: HttpClient,
    private supabaseService: SupabaseService,
  ) {}

  async download() {
    const session = await this.supabaseService.supabase.auth.getSession();
    const token = session.data?.session?.access_token;
    if (!token) return;

    const lambdaUrl = environment.lambdaUrl.replace(/\/$/, '');
    const url = `${lambdaUrl}/download-signed-documents?signed_contract_id=${this.data.signed_document_id}&action=download`;

    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const blob = await firstValueFrom(
      this.http.get(url, { headers, responseType: 'blob' })
    );

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `contract-${this.data.signed_document_id.substring(0, 8)}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    this.dialogRef.close();
  }
}
